import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class StaffCommonService {
  header: HttpHeaders;
  loggedInStaffID: string;
  loggedInStaffToekn: string | string[];
  loggedStaffObj: { IsEmailVerified: any; IsDeleted: any; };
  constructor(private http: HttpClient, private cookieService: CookieService, private _ngZone: NgZone) {
    // this.header = new HttpHeaders().set('Content-type', 'application/json');
    if (this.cookieService.get('staffAuth')) {
      const staffObj = JSON.parse( this.cookieService.get('staffAuth') );
      this.loggedInStaffID = staffObj.StaffInfo.ID;
      this.loggedStaffObj = staffObj.StaffInfo;
      this.loggedInStaffToekn = staffObj.Token;
    }
    this.header = new HttpHeaders({
         'Token': this.loggedInStaffToekn !== undefined ? this.loggedInStaffToekn : ''
      });
  }

  // Common Request Urls
  // Get List
  // Url: http://127.0.0.1:3000/company/
  getList(url) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.get<any>(environment.apiUrl + url, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  getListWithParams(url, params) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.post<any>(environment.apiUrl + url, params, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  clientVerification(url) {
    const httpOptions = {
      headers: this.header
    };
    return this.http
      .post<any>(environment.apiUrl + url,httpOptions )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

   emailSettingAdCancellation(url: string, params: {  ClientID: string, App: string;}) {
    const httpOptions = {
      headers: this.header
    };
    return this.http
      .post<any>(environment.apiUrl + url, params,httpOptions )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  // httpOptions Will be added for authentication put
  // Add List
  // Url: http://127.0.0.1:3000/company/
  /*{
    "name":  "Company Name",
    "email":  "Company@email.com",
    "tel":  "0000252525"
  }*/

  createList(url: string, params: { dt?: any; lang?: string; ID?: any; jobCategoryId?: any; workLocationId?: any; nativeLanguageId?: any; japaneseLevelId?: any; employmentTypeId?: any; durationOfWorkIds?: any; keyword?: string; ipadress?: any; IsActiveEmploye?: boolean; IsActiveJobSeeker?: boolean; extEmail?: any; CurrentLanguage?: string; }) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.post<any>(environment.apiUrl + url, params, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }



  // Update List (PUT Method)
  // Url: http://127.0.0.1:3000/company/1
  /*{
    "name":  "Company Name",
    "email":  "Company@email.com",
    "tel":  "0000252525"
  }*/

  updateList(url, params) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.put<any>(url, params, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  // Delete List (Patch Method)
  // Url: http://127.0.0.1:3000/company/1

  deleteList(url) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.delete<any>(url, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  staffLogin(url, params, headerObj) {
    return this.http.post<any>(url, params, headerObj).pipe(
      map((res : any) => {
        if( res.Success === true) {
          this._ngZone.run(() => {
          this.loggedStaffObj = res.StaffInfo;
          this.loggedInStaffID = res.StaffInfo.ID;
          this.loggedInStaffToekn = res.Token;
          this.header = new HttpHeaders({
            'Token': this.loggedInStaffToekn
         });
        });
        }
        return res;
      })
    );
  }

}
